var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 157,
    viewBox: "0 0 158 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 16.5H42C38.6848 16.5 35.5054 17.817 33.1612 20.1612C30.817 22.5054 29.5 25.6848 29.5 29V129C29.5 132.315 30.817 135.495 33.1612 137.839C35.5054 140.183 38.6848 141.5 42 141.5H117C120.315 141.5 123.495 140.183 125.839 137.839C128.183 135.495 129.5 132.315 129.5 129V54L92 16.5Z",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 16.5V54H129.5",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.75 112.5L94.25 83",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.75 83L94.25 112.5",
    stroke: "#4C5F71",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadRequest);
export default __webpack_public_path__ + "static/media/BadRequest.76ebc228d5bb516eb79f1f9cb7aa5918.svg";
export { ForwardRef as ReactComponent };